<script lang="ts">
	import { preventDefault } from "svelte/legacy"

	import { closeOverlay } from "overlay"
	import { MassUpdater } from "./MassUpdateController"
	import { Toast } from "toaster"

	let from: number = $state()
	let to: number = $state()
	let version: string = $state()

	let isLoading = $state(false)

	async function submit() {
		isLoading = true

		try {
			Toast.text("Initiating mass update procedure...")
			await MassUpdater.triggerUpdate(from, to, version)
			closeOverlay()
		} catch (e) {
			console.error(e)
			if (e.statusCode === 400)
				Toast.error(`v${version} is not a valid firmware version.`)
			else if (e.name === "RangeError") Toast.error(e.message)
			else
				Toast.error(
					"An unknown error occurred while initiating the mass update procedure..."
				)
			MassUpdater.reset()
		}

		isLoading = false
	}
</script>

<form class="updater-inputs" onsubmit={preventDefault(submit)}>
	<div class="flex-row">
		<div class="input-container">
			<label for="from-input"
				>From:
				<input
					id="from-input"
					type="number"
					placeholder="6000"
					bind:value={from}
				/>
			</label>
		</div>
		<div class="input-container">
			<label for="to-input"
				>To:
				<input id="to-input" type="number" placeholder="7000" bind:value={to} />
			</label>
		</div>
	</div>
	<div class="input-container">
		<label for="fw-version-input"
			>Version:
			<input
				id="fw-version-input"
				type="text"
				placeholder="3.2.0"
				bind:value={version}
			/>
		</label>
	</div>

	<button type="submit" disabled={isLoading}>Ok</button>
</form>

<style>
	.updater-inputs {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-grow: 1;
		padding-top: 1rem;
	}

	input[type="number"] {
		width: 5rem;
	}

	button {
		margin-top: 1rem;
	}
</style>
